export default [
  {
    header: 'navbars.reports',
    permission: ['user_management', 'collector', 'manager'],
    unique_name: 'reports-report-by-objects',
  },
  {
    title: 'navbars.report_contracts_by_objects',
    route: 'reports-by-objects',
    icon: 'FileTextIcon',
    permission: [
      'user_management',
      'finance_management',
      'collector',
      'manager',
    ],
    unique_name: 'reports-report-by-objects',
  },
  {
    title: 'navbars.by_objects',
    route: 'reports-new',
    icon: 'FileTextIcon',
    permission: ['user_management', 'finance_management'],
    unique_name: 'reports-reports-new',
  },
  {
    title: 'reports.total',
    route: 'reports-total',
    icon: 'FileTextIcon',
    permission: ['user_management', 'finance_management'],
    unique_name: 'reports-reports-total',
  },
  {
    title: 'navbars.reports-sold-apartments',
    route: 'reports-sold-apartments',
    icon: 'FileTextIcon',
    permission: ['user_management', 'finance_management'],
    unique_name: 'reports-sold-apartments',
  },
  {
    title: 'navbars.reports-not-sold-apartments',
    route: 'reports-not-sold-apartments',
    icon: 'FileTextIcon',
    permission: ['user_management', 'finance_management'],
    unique_name: 'reports-not-sold-apartments',
  },
  {
    title: 'navbars.reports-client-payments',
    route: 'reports-client-payments',
    icon: 'FileTextIcon',
    permission: ['user_management', 'finance_management'],
    unique_name: 'reports-client-payments',
  },
  {
    title: 'navbars.reports-clients',
    route: 'reports-clients',
    icon: 'FileTextIcon',
    permission: ['user_management', 'finance_management', 'manager'],
    unique_name: 'reports-on-clients',
  },
]